module.exports = {
	"name": "gb-tracker-client",
	"version": "3.3.3",
	"description": "GroupBy client-side event tracker",
	"keywords": [
		"groupby",
		"tracker",
		"recommendations"
	],
	"repository": {
		"type": "git",
		"url": "git+https://github.com/groupby/gb-tracker-client.git"
	},
	"main": "index.js",
	"scripts": {
		"test": "gulp test",
		"coverage:codacy": "cat ./coverage/lcov.info | codacy-coverage"
	},
	"author": "Eric Hacke",
	"license": "MIT",
	"devDependencies": {
		"chai": "^3.5.0",
		"codacy-coverage": "^2.0.0",
		"gulp": "^3.9.1",
		"gulp-eslint": "^3.0.1",
		"gulp-exec": "^2.1.3",
		"gulp-if": "^2.0.2",
		"gulp-istanbul": "^1.1.1",
		"gulp-mocha": "^3.0.1",
		"gulp-util": "^3.0.7",
		"istanbul": "^0.4.3",
		"lodash": "^4.16.6",
		"stream-combiner2": "^1.1.1",
		"stringify-object": "3.0.0",
		"supertest": "^2.0.1",
		"supertest-as-promised": "^4.0.2",
		"webpack": "^1.13.3",
		"webpack-stream": "^3.2.0"
	},
	"dependencies": {
		"deep-diff": "^0.3.4",
		"json-loader": "^0.5.4",
		"lz-string": "^1.4.4",
		"mocha": "^3.1.2",
		"schema-inspector": "^1.6.8",
		"uuid": "^2.0.3"
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/gb-tracker-client/package.json
// module id = 184
// module chunks = 0